import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { IConfig } from '@cian/config/shared';
import { IState as IAuthenticationWidgetState } from '@cian/authentication-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { withProvider } from '../../redux';
import { AuthWidget } from './AuthWidget';
import { IAdaptiveSettings } from '../../types/adaptiveSettings';
import { selectConfigValue } from '../../selectors/config';

interface IAuthWidgetContainerProps {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  authService: any;
}

export const AuthWidgetContainer = withProvider(
  ({ httpApi, logger, config, authService }: IAuthWidgetContainerProps) => {
    const subdomain = useSelector(selectConfigValue('subdomain'));
    const disabledSocials = config.get<string[]>('authentication.disabledSocials') || [];
    const { deviceType } = config.get<IAdaptiveSettings>('adaptiveSettings') || {};

    const preloadedState: Partial<IAuthenticationWidgetState> = {
      autoFocusDisabled: true,
    };

    return (
      <AuthWidget
        logger={logger}
        httpApi={httpApi}
        config={config}
        subdomain={subdomain}
        disabledSocials={disabledSocials}
        deviceType={deviceType}
        authService={authService}
        preloadedState={preloadedState}
      />
    );
  },
);
